import React, { useState, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import { checkNested } from 'srcReact/helpers/validator'
import ReactTable from 'srcReact/components/common2/ReactTable'
import { organizationSettingsActions } from 'srcReact/OrganizationSettingsPage'
import ReactMenu from 'srcReact/components/common2/ReactMenu'
import { redirectToPage } from 'srcReact/helpers/history'
import DesktopHeader from '../DesktopHeader'
import DeleteWorkplacePopin from 'srcReact/components/popinsContent/DeleteWorkplacePopin'
import Tile from 'srcReact/components/common2/Tile'
import Button from 'srcReact/components/common2/Button'
import { commonActions } from 'srcReact/components'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import { workplaceActions } from 'srcReact/WorkplacePage'

const Workplaces = () => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    common: { isMobile, isNative },
    organization: { current_organization },
    organizationSettings: { workplaces, loading, refresh }
  } = useSelector((state) => state)
  const [showDeleteWorkplaceModal, setShowDeleteWorkplaceModal] = useState(false)
  const [workplaceInfo, setWorkplaceInfo] = useState({
    workplace_id: '',
    name: '',
    status: ''
  })
  const [organizationId] = useState(getCurrentOrgId())

  useEffect(() => {
    if (checkNested(current_organization, 'info', 'id')) {
      dispatch(organizationSettingsActions.getOrganizationWorkplaceList(current_organization.info.id))
    }
  }, [current_organization && current_organization.info && current_organization.info.id, refresh])

  const options = (row) => {
    setWorkplaceInfo(row)
    let actions = []
    actions.push({
      text: t('organizationSettings.workplaces.actions.settings'),
      onClick: () => redirectToPage(`/0/workplace/settings/${row.workplace_id}?section=link_1`)
    })
    actions.push({
      text: t('organizationSettings.workplaces.actions.delete'),
      onClick: () => setShowDeleteWorkplaceModal(true)
    })
    return actions
  }
  const columns = useMemo(
    () => [
      {
        Header: t('organizationSettings.workplaces.columns.workplace'),
        id: 'name',
        accessor: (row, idx) => (
          <div className={styles.name}>
            <Tile className={styles.color} color={row.color} />
            <div>{row.name}</div>
          </div>
        )
      },
      {
        Header: t('organizationSettings.workplaces.columns.status'),
        id: 'status',
        accessor: (row, idx) => <div className={`${styles.status} ${styles[row.status]}`}>{row.status}</div>
      },
      {
        Header: t('organizationSettings.workplaces.columns.members'),
        accessor: 'members',
        className: styles.rowMembers
      },
      {
        Header: '',
        id: 'options',
        accessor: (row, idx) => <ReactMenu options={options(row)} />
      }
    ],
    []
  )
  const handleDeleteWorkplace = () => {
    dispatch(organizationSettingsActions.deleteWorkplace(workplaceInfo.workplace_id))
    setShowDeleteWorkplaceModal(false)
  }
  const handleNewWorkplace = () => {
    dispatch(
      workplaceActions.canAccess(
        'page-create-workplace',
        organizationId,
        null,
        () => redirectToPage(`/0/create-workplace?organization_id=${organizationId}`, isNative),
        () => dispatch(commonActions.openPopin('billing-workplace-popins'))
      )
    )
  }

  return (
    <div className={styles.workplacesWrapper}>
      {!isMobile && (
        <DesktopHeader
          title={t('organizationSettings.workplaces.title')}
          subtitle={t('organizationSettings.workplaces.subtitle')}
        />
      )}

      <ReactTable columns={columns} data={workplaces} className={styles.tableClassName} loading={loading} />

      <Button
        text={t('workplaceSettings.leadershipTeam.addMembers')}
        size='large'
        style='dashed'
        customStyle={styles.addNewbutton}
        handleClick={handleNewWorkplace}
      />

      <DeleteWorkplacePopin
        showDeleteWorkplaceModal={showDeleteWorkplaceModal}
        setShowDeleteWorkplaceModal={() => setShowDeleteWorkplaceModal(false)}
        heading={t('workplace.edit.title_popup_remove', { name: workplaceInfo.name })}
        description={t('workplace.edit.text_popup_remove')}
        handleCancelClick={() => setShowDeleteWorkplaceModal(false)}
        handleClick={handleDeleteWorkplace}
      />
    </div>
  )
}

export default Workplaces
